// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-LQhOWNzI","foot_link":"foot_link-1k5sBd2X","list":"list-34Jv5Zfn","link":"link-2RGul-tS","copyright":"copyright-55tMR5hU"};